import { put, takeEvery, call } from "redux-saga/effects";

import { showErrorMessage } from "../../../redux-saga/redux/toast";
import {
  getExtraMarketFilterStart,
  getExtraMarketFilterSuccess,
  getExtraMarketFilterFailure
} from "../../redux/extramarketFilter";
import extramarketFilterService from "../../services/extramarketFilter";
function* extramarketFilterWatcher() {
  yield takeEvery(getExtraMarketFilterStart, getExtraMarketFilterWorker);
}

function* getExtraMarketFilterWorker(action) {
  try {
    const { data, error } = yield call(
      extramarketFilterService.getExtraMarketFilter,
      action.payload
    );

    if (data) {
      yield put(getExtraMarketFilterSuccess(data));
    }
    if (error) {
      yield put(getExtraMarketFilterFailure());
      yield showErrorMessage({ msg: error });
    }
  } catch (error) {
    yield put(getExtraMarketFilterFailure());
    yield showErrorMessage({ msg: error });
  }
}

export default extramarketFilterWatcher;
